import { Controller } from '@hotwired/stimulus'
import 'select2'
import 'select2/dist/js/i18n/de'

// Connects to data-controller="postal-codes-input"
export default class extends Controller {
  connect() {
    this.initSelect2(this.element)
  }

  initSelect2(element) {
    $(element).select2({
      tags: true,
      matcher: () => null,
      placeholder: 'Alle',
      createTag: (params) => {
        if (!/^\d{2}-\d{3}$/.test(params.term)) {
          return null;
        }

        return {
          id: params.term,
          text: params.term
        }
      }
    })
  }

  disconnect() {
    $(this.element).select2('destroy')
  }
}
